var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.groupedFruits, function (fruits) {
    return [_c('v-divider'), _c('fruit', {
      key: 'grouped-fruits-' + fruits,
      attrs: {
        "id": fruits
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }